<template>
  <div
    class="favorite-button btn color-primary hover-color-hover-primary"
    v-bind:class="{ 'is-active': isActive }"
    @click="toggleState()"
  >
    <Icon iconName="icon-favorite" className="icon-24" />
  </div>
</template>

<script>
import Icon from "../Icon/Icon.vue";
import { mapState } from "pinia";
import { useProductStore } from "@/pages/product_card/stores/store_catalog";

export default {
  name: "FavoriteButton",
  components: {
    Icon,
  },
  props: {
    productId: {
      type: Number,
      default: 0,
    },
    className: {
      type: String,
      default: "",
    },
  },
  methods: {
    toggleState() {
      this.addWishList(
        this.productId || this.getSelectedProduct.id,
        this.getSelectedOffer?.id
      );
    },
  },
  computed: {
    ...mapState(useProductStore, [
      "wishList",
      "addWishList",
      "getSelectedProduct",
      "getSelectedOffer",
    ]),
    isActive() {
      let wishList = Array.from(this.wishList);
      let found = wishList.find((wishItem) => {
        return (
          Number(wishItem) ===
          Number(this.productId || this.getSelectedProduct.id)
        );
      });

      return !!found;
    },
  },
};
</script>

<style lang="scss">
@import "./favorite-button.scss";
</style>
